import Vue from "vue";
import Vuex from "vuex";
import { Vue2Storage } from "vue2-storage";
Vue.use(Vue2Storage);
import { vuexfireMutations, firestoreAction } from "vuexfire";
// import { Principal, Plans } from "@/interfaces/interfaces";
import { db } from "@/firebase/firebase";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    principals: [],
    principalId: "",
    principalItem: {},
    //PLANS
    plans: [],
    //DEPENDANTS
    dependants: [],
    dependantsCollection: {},
    spouses: [],
    spouseId: "",
    children: [],
    childId: []
  },
  mutations: {
    ...vuexfireMutations,
    principalId(state, { principalId }) {
      // @ts-ignore
      state.principalId = principalId;
      // this.$storage.set("principalId", principalId)
    },
    dependantsCollection(state, payload) {
      // @ts-ignore
      state.dependantsCollection = payload;
    }
  },
  actions: {
    dependantsCollection({ commit }, payload) {
      console.log(payload, "PAYLOAD");
      const dependantsCollection = db.collection("dependants").doc(payload.id);
      commit("dependantsCollection", dependantsCollection);
      // return dependantsCollection;
    },
    bindPrincipalsRef: firestoreAction(({ bindFirestoreRef }) => {
      return bindFirestoreRef("principals", db.collection("principals"));
    }),
    // @ts-ignore
    bindPrincipalItem: ({ state }, id) => {
      // @ts-ignore
      console.log("TWINS", state.principalId);
      db.collection("principals")
        .doc(id)
        .get()
        .then((docs) => {
          const Item = { id: docs.id, ...docs.data() };
          // @ts-ignore
          state.principalItem = Item;
        });
    },
    bindPlansRef: firestoreAction(({ bindFirestoreRef }) => {
      return bindFirestoreRef("plans", db.collection("plans"));
    }),
    bindDepandantsRef: firestoreAction(({ bindFirestoreRef }) => {
      return bindFirestoreRef("dependants", db.collection("dependants"));
    })
  }
});
